module.exports = __webpack_public_path__ + "static/feature_marty_sasha-939bc7b7b211848fbcb6247029f9713e.jpg";